export enum CategoryActionTypes {
    SET_CATEGORY_LIST = 'SET_CATEGORY_LIST',
    SET_CATEGORY_SELECTED = 'SET_CATEGORY_SELECTED',
    SET_CATEGORY_CONDITION = 'SET_CATEGORY_CONDITION',
    GET_CATEGORY_BY_URLKEY = 'GET_CATEGORY_BY_URLKEY',
    GET_PARENT_CATEGORY_BY_URLKEY = 'GET_PARENT_CATEGORY_BY_URLKEY',
}
